import AboutHeader from "../components/AboutHeader/AboutHeader";
import JoinTeamContainer from "../components/JoinTeam/JoinTeamContainer";
import { JoinTeamComponent } from '../styles/Layout.style'

const JoinTeam = () => {
  return (
    <JoinTeamComponent>
        <AboutHeader
        firstWord={"Únete al"}
        secondWord={"Equipo"}
        subtitleOne={"Forma parte de la familia Eupha"}
        subtitleTwoFirst={"Únete"}
        subtitleTwoSecond={"AL EQUIPO"}
      />
      <JoinTeamContainer />
    </JoinTeamComponent>
  )
}

export default JoinTeam